module.exports = "/_next/static/sounds/purchase.mp3";